import { render } from "./FooterBase.vue?vue&type=template&id=fdbe927c&scoped=true"
import script from "./FooterBase.vue?vue&type=script&lang=js"
export * from "./FooterBase.vue?vue&type=script&lang=js"

import "./FooterBase.vue?vue&type=style&index=0&id=fdbe927c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdbe927c"]])

export default __exports__